import { valueConverter } from 'aurelia';
import { formatDateTime } from '../services/date-format.service';

@valueConverter('dateTime')
export class DateTimeValueConverter {
  public toView(value: string | Date | null | undefined): string {
    return formatDateTime(value);
  }
}
